import {
    NinchatActionType,
    NinchatVerifyIdentityAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const verifyIdentity = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatVerifyIdentityAction}`,
    async (arg: NinchatActionParams<NinchatVerifyIdentityAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatVerifyIdentityAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
